import React, { useState } from 'react';
import { translate } from '../../Services/translation';

const BftRemoveFromCartButton = ({ onClick }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = () => {
        setIsLoading(true);
        Promise.resolve(onClick()).finally(() => setIsLoading(false));
    };

    return (
        <button
            className={`bft-remove-from-cart-btn${isLoading ? ' bft-remove-from-cart-btn--loading' : ''}`}
            onClick={handleClick}
            disabled={isLoading}
            aria-label={translate('bft.minicartremove')}
            title={translate('bft.minicartremove')}
        >
            <i className="bft-remove-from-cart-btn__icon" />
        </button>
    );
};

export default BftRemoveFromCartButton;
